import { createFileRoute } from '@tanstack/react-router';

import { LaboratoryCreate } from '@/module/Laboratory/LaboratoryCreate';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { researchCenterId } = Route.useParams();

  return <LaboratoryCreate researchCenterId={researchCenterId} />;
}
